import { Col, Divider, Row } from "antd";
import RemissionInfo from "./remission_info";
import { RemissionExcel } from "./remission_excel";

export default function RemissionList(){

    return(
        <Row>
            <Col lg={12} xs={12}>
                <div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Listado de remisiones</div>
                
            </Col>
            <Col lg={12} xs={12}>
                <RemissionExcel />
            </Col>
            <Col>
            <Divider />
            </Col>
            <Col lg={24} xs={24}>
                <RemissionInfo />
            </Col>
        </Row>
    );
}